// extracted by mini-css-extract-plugin
module.exports = {"emergencyContact":"member-operations__EmergencyContact__emergencyContact"};